export default "__VITE_ASSET__BKSzUpvC__"